export default {
  timeframe: {
    id: 'bo-seller_financial_report_filters_time_period',
    defaultMessage: 'Time period',
  },
  currency: {
    id: 'bo-seller_financial_report_filters_currency',
    defaultMessage: 'Currency',
  },
  applyFilters: {
    id: 'bo-seller_financial_report_filters_apply_filters',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'bo-seller_financial_report_filters_reset_filters',
    defaultMessage: 'Reset filters',
  },
  filters: {
    id: 'bo-seller_financial_report_filters_title',
    defaultMessage: 'Filters',
  },
  filter: {
    id: 'bo-seller_financial_report_filters_filter',
    defaultMessage: 'Filter',
  },
}
